import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bbdc65a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["type"]
const _hoisted_2 = { class: "btn-fields" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "btn-text" }
const _hoisted_5 = {
  key: 1,
  class: "material-icons btn-right-icon"
}
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClick'))),
    class: _normalizeClass([[
        _ctx.isEnabled ? '' : 'disabled',
        _ctx.setupButton,
        _ctx.setupBackground,
        _ctx.setupMargins,
      ], "d-inline-flex"]),
    type: _ctx.action
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.leftIcon)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["material-icons", { 'btn-left-icon': _ctx.type != 'tertiary' }])
          }, [
            (_ctx.leftIconDS)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "iconsDS",
                  src: require(`@/assets/iconsDS/${_ctx.leftIconDS}`),
                  alt: _ctx.leftIconDS
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.leftIcon), 1)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.text), 1),
      (_ctx.rightIcon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            (_ctx.rightIconDS)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "iconsDS",
                  src: require(`@/assets/iconsDS/${_ctx.rightIconDS}`),
                  alt: ""
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.rightIcon), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}